import React from 'react';

const ThemeTextInput = ({
	name = "",
	icon = null,
	onChange = null,
	errorMessage = null,
	type = "text",
	id = "",
	placeholder = "",
	disabled = false,
	value = "",
	label = "",
	inputMode,
	inputClassName = "",
	inputProps = {},
	isBottomMargin = true,
}) => {
	const inputId = id || name;
	const hasError = !!errorMessage;

	return (
		<div className={`relative form-group ${isBottomMargin ? 'mb-3' : ''}`}>
			{label ? (
				<div className="mb-2 block">
					<label htmlFor={inputId} className="block text-sm font-medium text-gray-900">
						{label}
					</label>
				</div>
			) : null}
			<div className="relative">
				{icon && (
					<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500">
						{typeof icon === 'function' ? icon() : icon}
					</div>
				)}
				<input
					id={inputId}
					name={name}
					type={type === 'phone' ? 'tel' : type}
					inputMode={inputMode ?? inputProps.inputMode ?? (type === 'phone' || type === 'numeric' ? 'numeric' : undefined)}
					placeholder={placeholder}
					value={value ?? ''}
					onChange={onChange}
					disabled={disabled}
					className={`block w-full rounded-lg border text-gray-900 placeholder-gray-500 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm ${icon ? 'pl-10' : 'pl-3'} pr-3 py-2 ${hasError ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50'} ${inputClassName}`.trim()}
					{...inputProps}
				/>
			</div>
			{errorMessage && (
				<p className="mt-1 text-sm text-red-600">{errorMessage}</p>
			)}
		</div>
	)
}

export default ThemeTextInput;